<template>
  <div class="imdiv shmim" v-on:click="zoom">
    <div class="square-filler" :class="{wide: artistData.wide, big: artistData.big}">
      <ix-router-link :to="'/artists/' + artist.portfolio_url">
        <transition name="fade">
          <img v-show="seen" :src="getImageUrl()" :srcset="getSourceSet()" :alt="artist.formatted_name" class="smain absim" />
        </transition>
      </ix-router-link>
    </div>
    <div class="greybar" v-show="loaded">
        <div>
          <div class="a-name">{{ artist.formatted_name }}</div>
          <div>
            <small-button v-on:click="zoom">{{ $nippets.portfolio.view }}</small-button>
          </div>
        </div>
        <div class="likebox-holder"><like-box :imageId="imageId" /></div>
    </div>
  </div>
</template>


<script>
import ViewablePanel from '@/mixins/ViewablePanel.js'
import LikeBox from '@/components/buttons/LikeBox.vue'
export default {
  components: {
    LikeBox
  },
  mixins: [ ViewablePanel ],
  props: {
    artistData: Object,
    pageSettings: String,
    wide: Boolean,
    big: Boolean
  },
  computed: {
    imageId () {
      return this.artistData.images[0].image_id
    }
  },
  data: function () {
    return {
      artist: { galleries: [] },
      rollovers: [],
      loaded: false
    }
  },
  created () {
    if(this.artistData.artist_id){
      this.loadArtist()
    }
  },
  methods: {
    zoom: function () {
      this.$emit('click', this.artist)
    },
    loadArtist: async function () {
      if(this.artistData) {
        this.artist = await this.$store.dispatch('fetchArtistById', this.artistData.artist_id)
        this.loaded = true
        this.setInView()
      }
    },
    getImageUrl: function() {
      if(this.artistData.images){
        let url = this.artistData.images[0].url
        if(this.artistData.wide) return this.$k.getImage320(url)
        else return this.$k.getImageCrop320(url)
      }
      return ''
    },
    //`${x320} 320w, ${x640} 640w, ${x960} 960w, ${this.src} 1200w` 
    getSourceSet () {
      if(this.artistData.images){
        let url = this.artistData.images[0].url
        let ss = []
        if(this.artistData.wide) {
          ss.push(this.$k.getImage320(url) + ' 320w')
          ss.push(this.$k.getImage500(url) + ' 500w')
          ss.push(this.$k.getZoomImage(url) + ' 1000w')
        }
        else {
          ss.push(this.$k.getImageCrop320(url) + ' 320w')
          ss.push(this.$k.getImageCrop500(url) + ' 500w')
        }
        let res = ss.join(', ')
        return res
      }
      return ''
    }
  },
  watch: {
    artistData: function () {
      if(this.artistData.artist_id) {
        this.loadArtist()
      }
    },
    pageSettings () {
      this.setInView()
    }
  }
}
</script>

<style scoped>

img.smain{
  position:absolute;
  top:50%;
  left:50%;
  width:100%;
  transform:translate(-50%,-50%);
  transition:all 0.5s ease;
}
.square-filler{
  position:relative;
}
.shmim{
  overflow:hidden;
}

.square-filler.wide{
  width:100%;
  padding-bottom:66%;
}

.shmim img.smain{
  width:100%;
  height:100%;
  object-fit: cover;
}
.shmim:hover img.smain{
  width:104%;
}

.greybar{
  position:absolute;
  transition:all 0.3s ease;
  bottom:0;
  left:0;
  width:100%;
  box-sizing:border-box;
  transform: translateY(100%);
}

.shmim:hover .greybar{
  transform:none;
}

</style>
